var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transaction-button"},[(_vm.isProgress)?_c('transaction-progress-button',{attrs:{"text":_vm.text,"disabled":_vm.disabled},on:{"click":_vm.onClick}}):_c('transaction-not-progress-button',{attrs:{"text":_vm.text,"disabled":_vm.disabled},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }